import { FC, useState } from 'react';
import { Button, Grid, Toolbar } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { useStyles } from '../../styles';
import { IS_SIGN_UP_ENABLED } from '../../../../environment/environment';
import LoginAndUserMenu from '../LoginAndUserMenu';
import Menu from '../Menu';
import LogoAndBlogLink from '../LogoAndBlogLink';
import InfluencerMenu from '../InfluencerMenu';

interface Props {
    isCreator?: boolean;
}

const HeaderMobile: FC<Props> = ({ isCreator }) => {
    const classes = useStyles();

    const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);

    const switchMenu = () => setIsMenuVisible(isVisible => !isVisible);

    return (
        <Toolbar className={classes.mobileToolbar}>
            <Grid container xs={12} direction="row" justify="space-between">
                <Grid item container className={classes.toolbarGrid}>
                    <LogoAndBlogLink />
                </Grid>

                <Grid
                    item
                    direction="row"
                    alignItems="center"
                    justify="flex-end"
                    container
                    className={classes.toolbarGrid}
                >
                    {IS_SIGN_UP_ENABLED && <LoginAndUserMenu />}

                    <Button onClick={switchMenu}>
                        <MenuIcon className={classes.hamburgerIcon} />
                    </Button>
                </Grid>

                {isMenuVisible && (
                    <Grid item xs={12}>
                        {isCreator ? <InfluencerMenu isMobile /> : <Menu isMobile />}
                    </Grid>
                )}
            </Grid>
        </Toolbar>
    );
};

export default HeaderMobile;
